module.exports = __webpack_public_path__ + "static/media/All-Region-Auditon-Materials-for-Region-20-MS.94db965a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/All-Region-Auditon-Materials-for-Region-20-MS.pdf
// module id = 202
// module chunks = 0